import React, { useEffect, useState } from 'react';
import { AppButton } from 'app/javascript/components/ui/app-button';
import { getCsrfToken } from 'app/javascript/utils';

type Props = {
  action: string;
  /** Devise の passwords#update は PUT。Rails の _method で上書きする */
  method?: 'post' | 'put';
  submitLabel: string;
  children: React.ReactNode;
};

/**
 * Devise のコントローラへ素直にフォーム POST する `<form>`。
 * TanStack Form は使わない。クライアント側バリデーションが無く、送信先は Rails（Devise）で
 * レスポンスもリダイレクト or 再描画のため、フォーム state を持つ意味がないため。
 * admin_page_component pack には rails-ujs が無く data-disable-with が効かないため、
 * 二重送信防止はここで送信中 state を持って行う。
 */
const DeviseForm: React.FC<Props> = ({ action, method = 'post', submitLabel, children }) => {
  const [submitting, setSubmitting] = useState(false);

  // ブラウザの「戻る」で bfcache から復元されると送信中のまま固まるため、復元時に解除する
  // （rails-ujs の data-disable-with も pageshow で再有効化している）
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setSubmitting(false);
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);
  // form で post するために致し方なく対応（ProductList.tsx と同様のパターン）
  const csrfToken = getCsrfToken();

  return (
    <form action={action} method="post" onSubmit={() => setSubmitting(true)}>
      <input type="hidden" name="authenticity_token" value={csrfToken} />
      {method === 'put' && <input type="hidden" name="_method" value="put" />}
      {children}
      <AppButton type="submit" className="w-full" disabled={submitting}>
        {submitting ? '送信中' : submitLabel}
      </AppButton>
    </form>
  );
};

export default DeviseForm;
